import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {FaTimes} from 'react-icons/fa'
import {useSelector} from 'react-redux'
import {resizeImage, validateImageFile} from '../../utils/imageUtils'

function Tab1({values, handleChange, setFieldValue, errors, touched}) {
  const cohortOptions = useSelector((state) => state?.cohort?.records)
  const languageOptions = useSelector((state) => state?.language?.records)
  const seasonOptions = useSelector((state) => state?.season?.records)
  const [isResizingImage, setIsResizingImage] = useState(false)

  let imageURL = ''
  if (values.isEdit) {
    if (values.image) {
      imageURL = values.image ? URL.createObjectURL(values.image) : ''
    } else {
      imageURL = values.imgUrl
    }
  } else {
    imageURL = values.image ? URL.createObjectURL(values.image) : ''
  }

  const handleFileChange = async (e) => {
    const file = e.currentTarget.files?.[0]
    if (!file) return

    try {
      setIsResizingImage(true)
      
      // Validate the file
      validateImageFile(file)
      
      // Resize the image with max dimension of 590
      const resizedFile = await resizeImage(file, 590)
      
      // Set the resized file in the form
      setFieldValue('image', resizedFile)
      setFieldValue('mediaId', null)
    } catch (error) {
      console.error('Error processing image:', error)
      alert(`Error processing image: ${error.message}`)
    } finally {
      setIsResizingImage(false)
      // Clear the input to allow selecting the same file again
      e.target.value = ''
    }
  }

  return (
    <div className='col-lg-12'>
      <div className='row align-items-start gy-3'>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Module Code</label>
          <input
            type='text'
            placeholder='Module code'
            name='code'
            value={values.code}
            onChange={handleChange}
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
          />
          {touched.code && errors.code && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.code}
              </span>
            </div>
          )}
        </div>

        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Module Title</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Module name'
            name='title'
            value={values.title}
            onChange={handleChange}
          />
          {touched.title && errors.title && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.title}
              </span>
            </div>
          )}
        </div>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Author Name</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Author name'
            name='authorName'
            value={values.authorName}
            onChange={handleChange}
          />
          {touched.authorName && errors.authorName && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.authorName}
              </span>
            </div>
          )}
        </div>

        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Cohort</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='cohort'
            value={values.cohortId}
            onChange={(e) => {
              const selectedCohort = cohortOptions.find((cohort) => cohort.id === e.target.value)
              setFieldValue('cohortId', selectedCohort?.id)
              setFieldValue('cohort', selectedCohort?.title)
            }}
          >
              <option disabled value={''}>
              Select Cohort
              </option>
            {cohortOptions.map((cohort) => (
              <option key={cohort.id} value={cohort.id}>
                {cohort.title}
              </option>
            ))}
          </select>
          {touched.cohortId && errors.cohortId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.cohortId}
              </span>
            </div>
          )}
        </div>

        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Language</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='layout-builder[layout][toolbar][width]'
            value={values.languageId}
            onChange={(e) => {
              const selectedLanguage = languageOptions.find(
                (language) => language.id === e.target.value
              )
              setFieldValue('languageId', selectedLanguage?.id)
              setFieldValue('language', selectedLanguage?.name)
            }}
          >
              <option disabled value={''}>
              Select Language
              </option>
            {languageOptions.map((language) => (
              <option key={language.id} value={language.id}>
                {language.name}
              </option>
            ))}
          </select>
          {touched.languageId && errors.languageId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.languageId}
              </span>
            </div>
          )}
        </div>

        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Season</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='cohort'
            value={values.seasonId}
            onChange={(e) => {
              const selectedSeason = seasonOptions.find((season) => season.id === e.target.value)
              setFieldValue('seasonId', selectedSeason?.id)
              setFieldValue('season', selectedSeason?.name)
            }}
          >
              <option disabled value={''}>
              Select Season
              </option>
            {seasonOptions.map((season) => (
              <option key={season.id} value={season.id}>
                {season?.name}
              </option>
            ))}
          </select>
          {touched.seasonId && errors.seasonId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.seasonId}
              </span>
            </div>
          )}
        </div>
        <div className='col-lg-4'>
          <label className='col-form-label  fw-bold fs-6 d-block'>
            For BlackForce Member
          </label>
          <label className='form-check d-inline-block form-check-custom form-check-solid form-switch mt-2'>
            <input
              className='form-check-input'
              type='checkbox'
              checked={values?.isForBlackforceMember}
              onClick={() => setFieldValue('isForBlackforceMember', !values?.isForBlackforceMember)}
            />
          </label>
        </div>
      </div>
      <label className='col-form-label required fw-bold fs-6 mt-8'>Banner Image</label>
      {!values.image && !values.imgUrl ? (
        <div>
          <div
            className='d-flex flex-column justify-content-center align-items-center bg-light-primary px-6 py-8 rounded-2 mb-7'
            onClick={() => !isResizingImage && document.getElementById('fileInput')?.click()}
            style={{
              cursor: isResizingImage ? 'not-allowed' : 'pointer',
              width: '400px',
              height: '200px',
            }}
          >
            {isResizingImage ? (
              <>
                <div className='spinner-border text-primary' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
                <span className='text-primary fw-semibold fs-6 mt-2'>Resizing image...</span>
              </>
            ) : (
              <>
                <KTSVG
                  path='/media/icons/duotune/arrows/arr075.svg'
                  className='svg-icon-3x svg-icon-primary d-block my-2'
                />
                <a href='#' className='text-primary fw-semibold fs-6'>
                  Upload Image
                </a>
              </>
            )}
          </div>
          {touched.image && errors.image && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.image}
              </span>
            </div>
          )}
          <input
            id='fileInput'
            type='file'
            accept='image/*'
            style={{display: 'none'}}
            disabled={isResizingImage}
            onChange={(e) => handleFileChange(e)}
          />
        </div>
      ) : (
        <div className='mb-8 mt-4' style={{position: 'relative', width: '400px', height: '200px'}}>
          <img src={imageURL} style={{width: '400px', height: '200px', objectFit:'cover'}} />
          <div
            className='rounded-3 p-1'
            style={{position: 'absolute', top: '4px', right: '4px', background: 'white'}}
          >
            <FaTimes
              style={{
                color: 'black',
                cursor: 'pointer',
                fontSize: '18px',
                backgroundPosition: 'center center',
              }}
              onClick={() => {
                setFieldValue('image', null)
                setFieldValue('imgUrl', null)
              }}
            />
          </div>
        </div>
      )}

      <div>
        <label className='col-form-label required fw-bold fs-6'>Short Description</label>
        <textarea
          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 w-50'
          style={{height: '200px'}}
          placeholder='Short description'
          name='description'
          value={values.description}
          onChange={(e) => {
            if (e.target.value.length <= 150) {
              handleChange(e)
            }
          }}
        />
        <small className='text-muted'>{values.description.length}/150 characters</small>
        {touched.description && errors.description && (
          <div className='fv-plugins-message-container'>
            <span role='alert' className='text-danger'>
              {errors.description}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default Tab1
